// Domestic
import andaman3 from '../images/statewiseCards/Andaman/andaman3.jpeg'
import chardham1 from '../images/statewiseCards/chardham/1.jpg'
import goa5 from '../images/statewiseCards/Goa/5.png'
import goldenTriangle1 from '../images/statewiseCards/Golden Triangle/1.png'
import ladakh1 from '../images/statewiseCards/Ladakh/1.png'
import northeast1 from '../images/statewiseCards/North East/1.png'
import himacha7 from '../images/statewiseCards/Himachal/7.png'
import Kashmir1 from '../images/statewiseCards/Kashmir/1.png'
import rajsthan4 from '../images/statewiseCards/Rajsthan/4.png'
import karnataka1 from '../images/statewiseCards/Karanatak/9.png'


// International
import dubai2 from '../images/contrywisecards/Dubai/2.png'
import hongKong1 from '../images/contrywisecards/Hongkong/1.png'
import malaysia3 from '../images/contrywisecards/Malaysis/3.png'
import maldives1 from '../images/contrywisecards/Maldives/3.png'
import singapore4 from '../images/contrywisecards/Singapore/4.png'
import southAfrica3 from '../images/contrywisecards/South Africa/3.png'
import thailand3 from '../images/contrywisecards/Thailand/3.png'
import othersInternational1 from '../images/contrywisecards/Other Internation/1.png'
import bhutan1 from '../images/contrywisecards/Bhutan/1.png'
import africa1 from '../images/contrywisecards/Africa/1.png'


export const BestDomestic = [
    {
        stateName: 'Ladakh',
        tourName: 'Ladakh',
        tourImg: ladakh1,
        tourPrice: '35,000',
        days: '8',
        night: '7',
        pdfLink:'https://drive.google.com/file/d/1CTfag5dKqVmvAN4ouKZ2XRls4uHpykbD/view?usp=sharing'
    },
    
    {
        stateName: 'Char Dham',
        tourName: 'Chardham Yatra',
        tourImg: chardham1,
        tourPrice: '36,000',
        days: '9',
        night: '8',
        pdfLink:'https://drive.google.com/file/d/13idzC-vxfzj6Rkh_9xhsP0KOrC1rBrGx/view?usp=sharing'
    },
    {
        stateName: 'Golden Triangle',
        tourName: 'Golden Triangle',
        tourImg: goldenTriangle1,
        tourPrice: '17,250',
        days: '6',
        night: '5',
        pdfLink:'https://drive.google.com/file/d/1h-lPIE3bhADsYM_hl2bIWyGWEIYld3DP/view?usp=sharing'
    },
    {
        stateName: 'Goa',
        tourName: 'Charming Goa',
        tourImg: goa5,
        tourPrice: '9,999',
        days: '4',
        night: '3',
        pdfLink:'https://drive.google.com/file/d/112ByYo0mTCpa4b6Q_b7Ahagl3N-dXEd-/view?usp=sharing'
    },
   
    {
        stateName: 'Karnataka',
        tourName: 'Karnataka',
        tourImg: karnataka1,
        tourPrice: '22,450',
        days: '7',
        night: '6',
        pdfLink:'https://drive.google.com/file/d/1Ea7svQ2-8MyR0zmUG-4zSS7slgBPpmEO/view?usp=sharing'
    },
    {
        stateName: 'Kashmir',
        tourName: 'Tour Of Kashmir',
        tourImg: Kashmir1,
        tourPrice: '13,570',
        days: '6',
        night: '5',
        pdfLink:'https://drive.google.com/file/d/1E_NhhtpohqwLDmpIK1fFx7if1oDaKYV0/view?usp=sharing'
    },
    
    {
        stateName: 'Rajasthan',
        tourName: 'Rajasthan',
        tourImg: rajsthan4,
        tourPrice: ' 27,720',
        days: '8',
        night: '7',
        pdfLink:'https://drive.google.com/file/d/1VHmqSPTy-hLp2PDRsDcq3rl1fXauxigl/view?usp=sharing'
    },
   
    {
        stateName: 'Himachal',
        tourName: 'Himachal',
        tourImg: himacha7,
        tourPrice: ' 6,700',
        days: '3',
        night: '2',
        pdfLink:'https://drive.google.com/file/d/1hIGbFkDiou7tfsotquroB3rhwxvGXh3V/view?usp=sharing'
    },
    {
        stateName: 'North East',
        tourName: ' Northeast',
        tourImg: northeast1,
        tourPrice: '13250',
        days: '6',
        night: '5',
        pdfLink:'https://drive.google.com/file/d/1V2O6U2yvqY_o8Th-ffpahQ5Zuc4wwXVG/view?usp=sharing'
    },
    {
        stateName: 'Andaman',
        tourName: 'Andaman Tour',
        tourImg: andaman3,
        tourPrice: '15,000',
        days: '5',
        night: '4',
        pdfLink:'https://drive.google.com/file/d/1gyVtcOofSiuVDr96bBY1WEx__2KNzodL/view?usp=sharing'
    },
    
   
]


export const BestInternational = [
    {
        countryName: 'Dubai',
        tourName: 'Dubai',
        tourImg: dubai2,
        tourPrice: '25,999',
        days: '5',
        night: '4',
        pdfLink: 'https://drive.google.com/file/d/12q6tLwAgCNII3Cm38W2p-4Nd5_PogpS1/view?usp=sharing'
    },
    {
        countryName: 'Hong Kong',
        tourName: 'Hong Kong',
        tourImg: hongKong1,
        tourPrice: '57,500',
        days: '5',
        night: '4',
        pdfLink: 'https://drive.google.com/file/d/1v0D-4jEME--24jOow8f1Uz4nRDGKJgYA/view?usp=sharing'
    },
    {
        countryName: 'Malaysia',
        tourName: 'Singapore and Malaysia',
        tourImg: malaysia3,
        tourPrice: '29,888 ',
        days: '5',
        night: '4',
        pdfLink: 'https://drive.google.com/file/d/1XvTftPvFHyjrPFEfABwmGzVN85P3hrpL/view?usp=sharing'
    },
    {
        countryName: 'Maldives',
        tourName: 'Maldives',
        tourImg:maldives1,
        tourPrice: '60,800',
        days: '4',
        night: '3',
        pdfLink: 'https://drive.google.com/file/d/1aK_eQC-UHsh2Qf7z-cwRAQL5_F3RkwGF/view?usp=sharing'
    },
    {
        countryName: 'Singapore',
        tourName: ' Singapore',
        tourImg:singapore4,
        tourPrice: '28,999',
        days: '5',
        night: '4',
        pdfLink: 'https://drive.google.com/file/d/1ef6k8JWQK9kxv5al4WGMaW9ag_VSKugk/view?usp=sharing'
    },
    {
        countryName: 'South Africa',
        tourName: 'South Africa',
        tourImg:southAfrica3,
        tourPrice: '79,400',
        days: '7',
        night: '6',
        pdfLink: 'https://drive.google.com/file/d/1z8LmvJd9hSyo6CGGkC3jYFp_8s3AaUkS/view?usp=sharing'
    },
    {
        countryName: 'Thailand',
        tourName: 'Thailand',
        tourImg: thailand3,
        tourPrice: '16,000',
        days: '0',
        night: '1',
        pdfLink: 'https://drive.google.com/file/d/1IUgjdy69O4Jxv5vZcMx8NrPZYLqqaZMW/view?usp=sharing'
    },
    {
        countryName: 'Canada',
        tourName: 'Canada',
        tourImg:othersInternational1,
        tourPrice: '83,950',
        days: '7',
        night: '6',
        pdfLink: 'https://drive.google.com/file/d/1ZV463lQenE_xKy-tmp-3_Q9WO1MWfTI5/view?usp=sharing'
    },
    {
        countryName: 'Bhutan',
        tourName: 'Bhutan',
        tourImg: bhutan1,
        tourPrice: '25,999',
        days: '6',
        night: '5',
        pdfLink: 'https://drive.google.com/file/d/1FM7DR35v0PYuvem_fMGdtMPkVH733n01/view?usp=sharing'
    },
    {
        countryName: 'USA',
        tourName: 'USA',
        tourImg:africa1,
        tourPrice: '2,59,999',
        days: '16',
        night: '15',
        pdfLink: 'https://drive.google.com/file/d/15IujoAn6gWmtBQ0_TkjzrN9F1NyphHmq/view?usp=sharing'
    },
]